/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IComponent, IComponentProps, ICoreContext } from '@msdyn365-commerce/core';
import React from 'react';

import { IOrderReturnInitiatedDetailsTableHeaderResources, OrderReturnInitiatedDetailsTableHeader } from './order-return-initiated-details-table/order-return-initiated-details-table-header.component';
import { OrderReturnInitiatedDetailsTableRow } from './order-return-initiated-details-table/order-return-initiated-details-table-row.component';

interface IOrderReturnInitiatedDetailsTableData {
    productReturnRows: IProductReturnRow[]
}

export interface IProductReturnRow {
    productName: string;
    productItemId: string;
    productQuantity: string;
    productRequestStatus: string;
}

export interface IOrderReturnInitiatedDetailsTableProps extends IComponentProps<IOrderReturnInitiatedDetailsTableData> {
    context: ICoreContext;
    className: string;

    resources: IOrderReturnInitiatedDetailsTableResources;
}

export interface IOrderReturnInitiatedDetailsTableResources extends IOrderReturnInitiatedDetailsTableHeaderResources {}

export interface IOrderReturnInitiatedDetailsTableComponent extends IComponent<IOrderReturnInitiatedDetailsTableProps> {}

/**
 *  Table component.
 * @param props - Configuration of the component.
 * @returns React node for the table.
 */
export const OrderReturnInitiatedDetailsTableComponent: React.FC<IOrderReturnInitiatedDetailsTableProps> = (props: IOrderReturnInitiatedDetailsTableProps) => {

    const rowClassName = `${props.className}__row`;
    const headerClassName = `${props.className}__header`;

    return (
        <table className={`${props.className}__table`}>
            <>
                <OrderReturnInitiatedDetailsTableHeader
                    context={props.context}
                    typeName={props.typeName}
                    id={headerClassName}
                    className={headerClassName}
                    resources={props.resources}
                    data={props.data.productReturnRows}
                />

            </>
            <>
                {props.data.productReturnRows.map((row, index) => {
                    return (
                        <OrderReturnInitiatedDetailsTableRow
                            context={props.context}
                            typeName={props.typeName}
                            id={`${rowClassName}-${index}`}
                            key={row.productItemId}
                            className={rowClassName}
                            data={{ rowData: row }}
                        />
                    );
                })}
            </>
        </table>
    );
};
